import { IWaterAreaCost } from '../../interfaces/iwater-area-cost';
import { UnitOfMeasure } from '../unit-of-measure';

export class WaterAreaCostBase {
  WaterAreaCostId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  LayFlatUnitCost: number | null;
  LayFlatUom: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IWaterAreaCost) {
    if (item) {
      this.WaterAreaCostId = item.WaterAreaCostId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.LayFlatUnitCost = item.LayFlatUnitCost;
      this.LayFlatUom = item.LayFlatUom;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);

    }
  }
}